export const Color = {
    Primary: "#4b0082",
    FontColor: "#212529"
}